export default class DateUtils {
	static addDays = (date: Date, days: number) => {
		if (date === undefined) return undefined
		if (date === null) return null
		date = new Date(date)
		date.setUTCDate(date.getUTCDate() + days)
		return date
	}

	static addHours = (date: Date, hours: number) => {
		if (date === undefined) return undefined
		if (date === null) return null
		date = new Date(date)
		date.setUTCHours(date.getUTCHours() + hours)
		return date
	}

	static addMinutes = (date: Date, minutes: number) => {
		if (date === undefined) return undefined
		if (date === null) return null
		date = new Date(date)
		date.setUTCMinutes(date.getUTCMinutes() + minutes)
		return date
	}
}
